<div class="supplementary-equipment">
  <div class="dialog-layout">

    <sc-dialog-title>
      <sc-dictionary-label dictionaryKey="tmc.transport.supplementaryEquipment.takeBack.title"></sc-dictionary-label>
    </sc-dialog-title>


    <div class="top-info">
      <app-transport-info-panel [carrier]="transport.carrier" [identifier]="transport.identifier"
      [driver]="transport.name" [scope]="transport.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content" [formGroup]="formGroup">
      <sc-flex vertical stretchContent class="no-field-space">

        @if (supplementaryEquipmendHandouted(transport)) {
          @for (se of transport.supplementaryEquipments; track se; let i = $index) {
            @if (i > 0) {
              <sc-content-spacer vertical></sc-content-spacer>
            }
            <sc-flex [formGroupName]="i">
              <sc-checkbox-field [disabled]="isFormReadonly()" [label]="se.name" formControlName="selected"></sc-checkbox-field>
              @if (se.identifier != null) {
                <sc-content-spacer></sc-content-spacer>
                <sc-string-field [disabled]="true"
                  labelDictionaryKey="tmc-common.equipment.entity.equipment.identifier"
                  formControlName="identifier"></sc-string-field>
              }
            </sc-flex>
          }
        }

        @if (!supplementaryEquipmendHandouted(transport)) {
          <div>
            <sc-dictionary-label dictionaryKey="tmc.transport.supplementaryEquipment.takeBack.label.nosupplementaryequipmenthandout"></sc-dictionary-label>
          </div>
        }

      </sc-flex>
    </div>

    <sc-actionbar>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-cancel-button (click)="cancel()"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-save-button primary (click)="save()" primary [disabled]="isSaveDisabled()"></sc-save-button>
    </sc-actionbar>
  </div>

</div>
